export default "__VITE_ASSET__x1k$51dY__"